import {
    Directive,
    HostListener,
    ElementRef,
    OnInit,
    Injector
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appThousandSeparator]'
})
export class ThousandSeparatorDirective implements OnInit {
    private control!: NgControl['control'];

    constructor(
        private el: ElementRef<HTMLInputElement>,
        private injector: Injector
    ) { }

    ngOnInit(): void {
        const ngControl = this.injector.get(NgControl, null, { self: true, optional: true });
        if (!ngControl?.control) {
            throw new Error('appThousandSeparator must be used with formControl/formControlName');
        }
        this.control = ngControl.control;
        this.onInput();
    }

    @HostListener('input')
    onInput(): void {
        // const inputValue = this.el.nativeElement.value.replace(/,/g, '');
        // if (!isNaN(Number(inputValue))) {
        //     this.control!.setValue(+inputValue, { emitEvent: false });
        //     this.el.nativeElement.value = Number(inputValue)
        //         .toLocaleString('en-US');
        // } else {
        //     const value = this.control!.value.replace(/\D/g, '');
        //     this.control!.setValue(value);
        //     this.el.nativeElement.value = Number(value)
        //         .toLocaleString('en-US');
        // }
        this.formatValue(this.el.nativeElement.value);
    }

    private formatValue(rawValue: string) {
        // 1) Remove commas
        let value = rawValue.replace(/,/g, '');

        // 2) Allow only digits and at most one dot
        //    Split on dot to separate integer/decimal
        const parts = value.split('.');
        let intPart = parts[0].replace(/\D/g, '');
        let decPart = !!parts[1] ? parts[1] : '0';

        // If there were multiple dots, ignore extra
        if (parts.length > 2) {
            // join any extra parts back into decimal
            decPart = parts.slice(1).join('').replace(/\D/g, '');
        }

        // Optionally limit decimal places (e.g. 2)
        if (decPart.length > 2) {
            decPart = decPart.substring(0, 2);
        }

        // 3) Format integer part with commas
        const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        // 4) Recombine
        const newValue = decPart.length > 0
            ? `${formattedInt}.${decPart}`
            : formattedInt;


        // 5) Update both view and form control
        this.el.nativeElement.value = newValue;
        // Use parseFloat to keep decimal, or leave as string if preferred
        const numeric = decPart.length > 0
            ? parseFloat(`${intPart}.${decPart}`)
            : parseInt(intPart, 10) || null;


        this.control!.setValue(numeric, { emitEvent: false });
    }
}
